import { Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

export type BooksNotFoundRefreshModalProps = {
    orderedBook: Array<{ books?: unknown[] | null | undefined }>;
    loadingClassBooks: boolean;
    booksAllList: unknown;
    allBooks: unknown[] | undefined;
    currentUser: { role?: string } | null | undefined;
    currentClass: { id?: string; books_group?: unknown[] | null | undefined } | null | undefined;
};

const BooksNotFoundRefreshModal = ({
    orderedBook,
    loadingClassBooks,
    booksAllList,
    allBooks,
    currentUser,
    currentClass,
}: BooksNotFoundRefreshModalProps) => {
    const refreshTriggeredRef = useRef(false);
    const [showRefreshModal, setShowRefreshModal] = useState(false);

    useEffect(() => {
        if (!currentClass?.id) {
            refreshTriggeredRef.current = false;
            return;
        }

        const sessionKey = `books_refresh_${currentClass.id}`;
        const alreadyTriggered = sessionStorage.getItem(sessionKey) === 'true';

        if (alreadyTriggered) {
            refreshTriggeredRef.current = true;
            return;
        }

        if (
            currentUser?.role === 'student' &&
            currentClass?.id &&
            (currentClass.books_group?.length ?? 0) > 0 &&
            !loadingClassBooks &&
            booksAllList !== undefined &&
            !refreshTriggeredRef.current
        ) {
            const timeoutId = setTimeout(() => {
                const currentSessionKey = `books_refresh_${currentClass?.id}`;
                if (refreshTriggeredRef.current || sessionStorage.getItem(currentSessionKey) === 'true')
                    return;

                const userBooks = allBooks;
                const hasBooks = userBooks && userBooks.length > 0;
                const hasOrderedBooks = orderedBook?.some((order) => order.books && order.books.length > 0);

                if (!hasBooks || !hasOrderedBooks) {
                    refreshTriggeredRef.current = true;
                    sessionStorage.setItem(currentSessionKey, 'true');
                    setShowRefreshModal(true);
                }
            }, 3000);

            return () => clearTimeout(timeoutId);
        }
        return undefined;
    }, [
        currentUser?.role,
        currentClass?.id,
        currentClass?.books_group?.length,
        loadingClassBooks,
        orderedBook,
        booksAllList,
        allBooks,
    ]);

    const handleRefreshModalConfirm = () => {
        setShowRefreshModal(false);
        window.location.reload();
    };

    return (
        <Modal
            open={showRefreshModal}
            title="Books Not Found"
            onOk={handleRefreshModalConfirm}
            okText="Refresh"
            cancelButtonProps={{ style: { display: 'none' } }}
            closable={false}
            maskClosable={false}
            keyboard={false}
            styles={{ mask: { backdropFilter: 'blur(5px)' } }}
            mask={true}
        >
            Please refresh the page.
        </Modal>
    );
};

export default BooksNotFoundRefreshModal;
